import React from "react";
import PropTypes from "prop-types";

export default function ImageDrawCard({ title, thumb, image, onClick }) {
    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") onClick(title, image);
    };

    return (
        <div className="col">
            <div
                className="card position-relative overflow-hidden border-0 shadow-sm h-100 rounded-3 image-card"
                role="button"
                tabIndex={0}
                onClick={() => onClick(title, image)}
                onKeyDown={handleKeyDown}
            >
                <img src={thumb} alt={title} className="card-img-top rounded-3" />
                <div className="overlay d-flex flex-column justify-content-center align-items-center text-white text-center">
                    <i className="bi bi-pencil-fill fs-3 mb-2"></i>
                    <button
                        type="button"
                        className="btn btn-light btn-sm fw-semibold px-3"
                        onClick={(e) => {
                            e.stopPropagation();
                            onClick(title, image);
                        }}
                    >
                        Draw
                    </button>
                </div>
                <div className="card-body text-center p-2">
                    <small className="text-muted d-block">{title}</small>
                </div>
            </div>
        </div>
    );
}

ImageDrawCard.propTypes = {
    title: PropTypes.string.isRequired,
    thumb: PropTypes.string.isRequired,
    image: PropTypes.any.isRequired,
    onClick: PropTypes.func.isRequired,
};
